import { ERROR, SUCCESS } from 'apps/promo/constants/Constants';
import { random128Hex } from 'apps/promo/helpers/utils';

export const CHANGE_LANG = 'CHANGE_LANG';
export const UPDATE_CURRENT_SECTION = 'UPDATE_CURRENT_SECTION';
export const TOGGLE_SPINNER = 'TOGGLE_SPINNER';
export const TOGGLE_CUSTOM_SPINNER = 'TOGGLE_CUSTOM_SPINNER';
export const TOGGLE_POPUP = 'TOGGLE_POPUP';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const TOGGLE_MODAL_WITH_TIMER = 'TOGGLE_MODAL_WITH_TIMER';
export const TOGGLE_CLOUD_FLARE_MODAL = 'TOGGLE_CLOUD_FLARE_MODAL';
export const TOGGLE_SNACKBAR = 'TOGGLE_SNACKBAR';
export const SCROLL_TOP = 'SCROLL_TOP';
export const TOGGLE_NAV_MODAL = 'TOGGLE_NAV_MODAL';
export const TOGGLE_NAV_BAR = 'TOGGLE_NAV_BAR';
export const UPDATE_MESSAGES = 'UPDATE_MESSAGES';
export const ADD_MESSAGE_BODY = 'ADD_MESSAGE_BODY';
export const UPDATE_OFAKIM_IMG_URL = 'UPDATE_OFAKIM_IMG_URL';
export const UPDATE_AUTH_PROMO_BLOCK = 'UPDATE_AUTH_PROMO_BLOCK';
export const REMOVE_MESSAGE_FROM_MESSAGE_BODY = 'REMOVE_MESSAGE_FROM_MESSAGE_BODY';
export const UPDATE_REDUX = 'UPDATE_REDUX';

const LOCK_CONTAINER = 'lock_container';
const CONTENT = 'content';

export const updateReduxAction = () => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_REDUX,
            }),
        );
    };
};

export const updateCurrentSiteSection = (currentSiteSection) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_CURRENT_SECTION,
                currentSiteSection: currentSiteSection,
            }),
        );
    };
};
export const addMessageBody = (text, paymentId, paymentStatus) => {
    return (dispatch) => {
        const status = isNaN(paymentStatus) ? paymentStatus : parseInt(paymentStatus) === 90 ? SUCCESS : ERROR;
        const statusForHistory = isNaN(paymentStatus) ? paymentStatus : parseInt(paymentStatus);
        const paymentIdForHistory = parseInt(paymentId);
        return Promise.resolve(
            dispatch({
                type: ADD_MESSAGE_BODY,
                message: [
                    {
                        expires: 0,
                        messageId: `${paymentId}-${paymentStatus}`,
                        value: text,
                        autoClose: false,
                        messageType: status,
                        buttons: null,
                        status: statusForHistory,
                        paymentId: paymentIdForHistory,
                    },
                ],
            }),
        );
    };
};
export const addErrorMessageBody = (text) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: ADD_MESSAGE_BODY,
                message: [
                    {
                        expires: 0,
                        messageId: random128Hex(),
                        value: text,
                        autoClose: true,
                        messageType: ERROR,
                        buttons: null,
                    },
                ],
            }),
        );
    };
};
export const updateMessages = (messages) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_MESSAGES,
                messages: messages,
            }),
        );
    };
};

/**
 * @deprecated
 */
export const togglePopup = (isShow, component = {}, canClose = true) => {
    return (dispatch, getState) => {
        if (__isBrowser__ && !getState().app.isShowModal) {
            document.body.style.overflow = isShow ? 'hidden' : '';
        }
        return Promise.resolve(
            dispatch({
                type: TOGGLE_POPUP,
                isShow: isShow,
                component: component,
                canClose: canClose,
            }),
        );
    };
};

export const toggleModal = (isShow, component) => {
    if (__isBrowser__) {
        document.body.style.overflow = isShow ? 'hidden' : '';
    }
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: TOGGLE_MODAL,
                isShow: isShow,
                component: component,
            }),
        );
    };
};
export const toggleModalWithTimer = (isShow, message = '', onCloseFunction = false) => {
    return (dispatch, getState) => {
        if (__isBrowser__ && !getState().app.isShowModal && !getState().app.isShowPopup) {
            document.body.style.overflow = isShow ? 'hidden' : '';
        }
        return Promise.resolve(
            dispatch({
                type: TOGGLE_MODAL_WITH_TIMER,
                isShow: isShow,
                message,
                onCloseFunction,
            }),
        );
    };
};
export const toggleCloudFlareModal = (isShow, path = '', options = {}) => {
    if (__isBrowser__) {
        document.body.style.overflow = isShow ? 'hidden' : '';
    }
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: TOGGLE_CLOUD_FLARE_MODAL,
                payload: {
                    isShow,
                    path,
                    options,
                },
            }),
        );
    };
};
export const toggleSnackBar = (isShow, message = '') => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: TOGGLE_SNACKBAR,
                isShow: isShow,
                message,
            }),
        );
    };
};

export const toggleNavModal = (isShow) => {
    document.body.classList.toggle('navigation-opened', isShow);
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: TOGGLE_NAV_MODAL,
                isShow: isShow,
            }),
        );
    };
};
export const scrollTop = (isScroll) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: SCROLL_TOP,
                isScroll: isScroll,
            }),
        );
    };
};

export const toggleNavBar = (isShow) => {
    return (dispatch, getState) => {
        if (__isBrowser__ && !getState().app.isShowModal && !getState().app.isShowPopup) {
            document.body.style.overflow = isShow ? 'hidden' : '';
        }
        return Promise.resolve(
            dispatch({
                type: TOGGLE_NAV_BAR,
                isShow: isShow,
            }),
        );
    };
};
export const toggleSpinner = (isShow) => {
    const content = document.getElementById(CONTENT);
    if (content) {
        if (isShow) {
            content.classList.add(LOCK_CONTAINER);
            content.style.opacity = '0.3';
        } else {
            content.classList.remove(LOCK_CONTAINER);
            content.style.opacity = '1';
        }
    }
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: TOGGLE_SPINNER,
                isShow: isShow,
            }),
        );
    };
};
export const toggleCustomSpinner = (isShow) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: TOGGLE_CUSTOM_SPINNER,
                isShow: isShow,
            }),
        );
    };
};
export const removeMessageFromMessageBody = (messageId) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: REMOVE_MESSAGE_FROM_MESSAGE_BODY,
                messageId: messageId,
            }),
        );
    };
};
export const changeLang = (lang) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: CHANGE_LANG,
                lang: lang,
            }),
        );
    };
};
export const updateAuthPromoBlock = (authPromoAction) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_AUTH_PROMO_BLOCK,
                authPromoAction: authPromoAction,
            }),
        );
    };
};
export const addOfakimImg = (imgUrl, docId, docNumber) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_OFAKIM_IMG_URL,
                docId: docId,
                kycDoc: {
                    id: docId,
                    imgUrl: imgUrl,
                    value: docNumber,
                },
            }),
        );
    };
};
